export const acceptedFormats = 'JPG, JPEG, PNG, PDF'
export const maxFileSize = 5
export const callerNumber = '+41 315420244'
export const acceptedImageFormats = 'JPG, JPEG, PNG'
